import "owl.carousel";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

const gallery = {
  init: function () {
    $("body").on("click", ".close-thumbs", function (e) {
      e.preventDefault();
      $(".overlay-thumbs-outer").toggleClass("open");
    });
  },

  gallery: false,
  cur_post_id: 0,
  thumbImages: [],
  options: {
    shareEl: false,
    fullscreenEl: false,
    history: false,
    focus: false,
    bgOpacity: 1,
    closeOnScroll: false,
    tapToToggleControls: false,
    clickToCloseNonZoomable: false,
    showAnimationDuration: 200,
    hideAnimationDuration: 200,
    maxSpreadZoom: 0,
    galleryUID: 1,
    barsSize: {
      top: 44,
      bottom: 0,
    },
    closeElClasses: [],
  },
  oOptions: {
    items: 13,
    itemsDesktop: [1199, 13],
    itemsDesktopSmall: [979, 9],
    itemsTablet: [768, 7],
    itemsMobile: [479, 3],
    pagination: false,
    responsiveRefreshRate: 100,
    afterInit: function (el) {
      el.find(".owl-item").eq(0).addClass("synced");
    },
    afterMove: function () {
      var number = this.currentItem;

      gallery.oThumbs
        .find(".owl-item")
        .removeClass("synced")
        .eq(number)
        .addClass("synced");

      if (gallery.data("owlCarousel") !== undefined) {
        var sync2visible = [];
        if (gallery.oThumbs && gallery.oThumbs.data("owlCarousel")) {
          sync2visible = gallery.oThumbs.data("owlCarousel").owl.visibleItems;
        }

        var found = false;
        for (var i in sync2visible) {
          if (number === sync2visible[i]) {
            found = true;
          }
        }
      }
    },
  },

  oThumbs: false,

  setup_data: function (post_id, img_index) {
    var display;

    $(".pswp__button").removeClass("inactive");

    $(".pswp").attr("data-post-id", post_id);
    var images = gallery.thumbImages;
    $(".overlay-thumbs").html("");
    if (gallery.oThumbs && gallery.oThumbs.data("owlCarousel")) {
      gallery.oThumbs.data("owlCarousel").destroy();
    }

    if (images.length < 2) {
      display = "none";
    } else {
      display = "block";
      if (!$(".overlay-thumbs").children("div").length) {
        for (var i = 0; i < images.length; i++) {
          $(".overlay-thumbs").append(
            '<img data-index="' + i + '" src="' + images[i].thumb + '" />'
          );
        }
      }
    }

    $(".overlay-thumbs-outer").css("display", display);

    $(".gal-info .total").text(images.length);
    return images;
  },

  set_hotspots: function (index, item) {
    if (typeof item.hotspots != "undefined") {
      var elem = $(item.container).closest(".pswp__item");
      var img = elem.find("img");
      var wrap = $(
        '<div class="hotspots"><a href="#" class="photo-nav nav-prev"></a><a href="#" class="photo-nav nav-next"></a></div>'
      );
      var regExp = /scale\(([^)]+)\)/;
      var match = regExp.exec(elem.find(".pswp__zoom-wrap").attr("style"));

      var width = img.width();
      var height = img.height();

      wrap.css({
        width: width,
        height: height,
      });

      if ($(item.container).length) {
        wrap.css({
          top: $(img).position().top,
          left: $(img).position().left,
        });
      }

      var desc_wrap = $('<div class="desc-wrap"></div>');
      desc_wrap.append(
        '<a href="#" class="desc-close js-desc-close">Aizvērt</a>'
      );

      // Place hotspots
      if (typeof item.hotspots != undefined) {
        for (var i = 0; i < item.hotspots.length; i++) {
          if (item.hotspots[i].loc.length) {
            var more;
            var pin = $(
              '<div class="pin" data-id="' + i + '"><span>i</span></div>'
            );
            var d_text = item.hotspots[i].desc
              ? '<div class="entry-content"><p>' +
                item.hotspots[i].desc +
                "</p></div>"
              : "";
            //d_text = d_text.substring(1, d_text.length - 1);
            var desc = $(
              '<div class="pin-desc" data-id="' +
                i +
                '"><h2>' +
                item.hotspots[i].title +
                "</h2>" +
                d_text +
                "</div>"
            );
            var pos = JSON.parse(item.hotspots[i].loc);
            pin.css({
              top: pos.top + "%",
              left: pos.left + "%",
            });

            wrap.append(pin);
            desc_wrap.append(desc);

            if (item.hotspots[i].more) {
              var moreItems = item.hotspots[i].more.map(function (item) {
                return (
                  '<div class="pin__more__item"><div class="pin__more__left"><a href="' +
                  item.url +
                  '">' +
                  item.title +
                  '</a></div><div class="pin__more__right"><a href="' +
                  item.url +
                  '">Skatīt</a></div></div>'
                );
              });
              more = $(
                '<div class="pin__more"><div class="pin__more__toggle">Skatīt šī produkta aprakstu sadaļās</div><div class="pin__more__content"><div class="pin__more__inner">' +
                  moreItems.join("") +
                  "</div></div></div>"
              );
              desc.append(more);
            }
            if (item.hotspots[i].manufacturer) {
              more = $(
                '<h3 class="pin__brand__title">Konkrētais ražotājs:</h3><div class="partner"><a href="/" target="_blank"><img src="' +
                  item.hotspots[i].manufacturer +
                  '" alt=""></a></div>'
              );
              desc.append(more);
            }
          }
        }
      }

      elem.find(".pswp__zoom-wrap").append(wrap);
      elem.append('<div class="desc-wrap__bg js-desc-close"></div>');
      elem.append(desc_wrap);

      elem.on("click", ".js-desc-close", function (e) {
        e.preventDefault();
        $(".pin").removeClass("current");
        elem.children(".desc-wrap").removeClass("visible");
        $(".pswp__container").removeClass("desc--open");
      });

      $("body").on("click tap", ".pin", function (e) {
        e.preventDefault();
        var id = $(this).attr("data-id");
        $(".pin").removeClass("current");
        $(this).addClass("current");
        elem.children(".desc-wrap").addClass("visible");
        $(".pswp__container").addClass("desc--open");
        elem
          .children(".desc-wrap")
          .children(".pin-desc")
          .removeClass("visible");
        elem
          .children(".desc-wrap")
          .children('.pin-desc[data-id="' + id + '"]')
          .addClass("visible");
      });
    }
  },

  update: function (item, index) {
    var width, height;

    var elem = $(item.container).closest(".pswp__item");
    elem.children(".desc-wrap").removeClass("visible");
    $(".pswp__container").removeClass("desc--open");
    $(".pin").removeClass("current");
    var img = elem.find("img");
    var regExp = /scale\(([^)]+)\)/;
    var match = regExp.exec(elem.find(".pswp__zoom-wrap").attr("style"));

    if (match != null) {
      width = parseFloat(match[1]) * img.width();
      height = parseFloat(match[1]) * img.height();
    } else {
      width = elem.find(".pswp__zoom-wrap").width();
      height = elem.find(".pswp__zoom-wrap").width();
    }

    if (elem.find(".hotspots").length == 0) {
      gallery.set_hotspots(index, item);
    } else {
      var wrap = elem.find(".hotspots");
      // wrap.css({
      //     width: width,
      //     height: height,
      //     top: 0,
      //     top: $(item.container).position().top,
      //     left: $(item.container).position().left
      // });
    }
  },

  init_oThumbs: function () {
    var self = gallery;

    self.oThumbs = $(".overlay-thumbs").owlCarousel(self.oOptions);

    self.oThumbs.on("click", ".owl-item", function (e) {
      e.preventDefault();
      var number = $(this).data("owlItem");
      var index = $(this).find("img").attr("data-index");
      if (typeof index != "undefined") {
        number = index;
      }
      self.gallery.goTo(number);
    });
    $("body")
      .on("click", ".gal-prev", function (e) {
        e.preventDefault();
        self.oThumbs.trigger("owl.prev");
      })
      .on("click", ".gal-next", function (e) {
        e.preventDefault();
        self.oThumbs.trigger("owl.next");
      });
  },

  open_photoswipe: function (num, images, set_points) {
    var self = gallery;
    self.thumbImages = images;
    self.setup_data("fuc..", num);

    var pswpElement = document.querySelectorAll(".pswp")[0];

    self.options.galleryUID = self.cur_post_id;

    self.gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      images,
      self.options
    );
    self.gallery.init();

    $(document).bind("touchmove", function (event) {
      event.preventDefault();
    });

    var total = self.gallery.options.getNumItemsFn();

    if (typeof num != "undefined") {
      const img = images[num];

      self.gallery.goTo(num);
      $(".gal-info .current").text(num + 1);
    }

    $("body")
      .on("click", ".photo-nav.nav-next", function (e) {
        e.preventDefault();
        self.gallery.next();
      })
      .on("click", ".photo-nav.nav-prev", function (e) {
        e.preventDefault();
        self.gallery.prev();
      });

    setTimeout(function () {
      if (typeof set_points == "function") {
        set_points(num, images[num]);
      }
    }, 400);

    self.gallery.listen("afterChange", function () {
      var item = self.gallery.currItem;
      var index = self.gallery.getCurrentIndex();

      $(".overlay-thumbs").find(".owl-item.synced").removeClass("synced");
      $(".overlay-thumbs").find(".owl-item").eq(index).addClass("synced");

      setTimeout(function () {
        gallery.update(item, index);
      }, 200);
    });

    self.gallery.listen("resize", function () {
      var item = self.gallery.currItem;
      var index = self.gallery.getCurrentIndex();
      setTimeout(function () {
        gallery.update(item, index);
      }, 50);
    });

    self.gallery.listen("close", function () {
      $(document).unbind("touchmove");
      if (typeof redirect != "undefined") {
        document.location.href = redirect;
      }
    });

    self.init_oThumbs();

    self.gallery.listen("afterChange", function () {
      var cur = self.gallery.getCurrentIndex();
      $(".gal-info .current").text(parseInt(cur) + 1);

      self.oThumbs.trigger("owl.goTo", cur);
    });
  },
};

export default gallery;
